<script>
import Header from '@/components/core/Header';
import Footer from '@/components/core/Footer';

export default {
  components: {
    Header,
    Footer,
  },
};
</script>

<template>
  <div id="wrap">
    <Header />
    <slot />
    <Footer />
  </div>
</template>
